import request from "@/utils/request"; // 確保這是指向你寫了攔截器的那個檔案
import Apis from "./Apis";

export default class CCOnboardFormService {

  static async validateOTP(requestModel: object) {
    return await request.post(`${Apis.FULL_URL}/otp/validateOTP`, {
      requestModel: requestModel
    });
  }

  static async requestOTP(requestModel: object, token: string) {
    return await request.post(
      `${Apis.FULL_URL}/otp/requestOTP`,
      { requestModel: requestModel },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
  static async resendOTP(requestModel: object, token: string) {
    return await request.post(
      `${Apis.FULL_URL}/otp/resendOTP`,
      { requestModel: requestModel },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }

  static async validateEmailOTP(requestModel: object) {
    return await request.post(`${Apis.FULL_URL}/otp/validateEmailOTP`, {
      requestModel: requestModel
    });
  }

  static async requestEmailOTP(requestModel: object, token: string) {
    return await request.post(
      `${Apis.FULL_URL}/otp/requestEmailOTP`,
      { requestModel: requestModel },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }


  static async resendEmailOTP(requestModel: object, token: string) {
    return await request.post(
      `${Apis.FULL_URL}/otp/resendEmailOTP`,
      { requestModel: requestModel },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }


  static async updateStatus(requestModel: object, token: string) {
    return await request.post(
      `${Apis.FULL_URL}/cc/updateOtpFlag`,
      { requestModel: requestModel },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
}